module.exports = __webpack_public_path__ + "07a71ca617ccd5f6e0f30383997136b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/edit.png
// module id = 212
// module chunks = 0